
    <ion-app class="ionApp {{ isDesktop ? 'isDesktop' : 'isMobile' }}">
      <ion-split-pane disabled="true">
        <ion-menu>
          <ion-header>
            <ion-toolbar color="primary">
              <ion-title>Menu</ion-title>
            </ion-toolbar>
          </ion-header>

          <ion-content>

            <ion-list *ngIf="appPages">

            <div *ngFor="let p of appPages">

              <ion-menu-toggle auto-hide="false" *ngIf="p.url">
                <ion-item
                  *ngIf="p.isVisible"
                  [routerDirection]="'root'"
                  [routerLink]="[p.url]"
                >
                  <ion-icon slot="start" [name]="p.icon"></ion-icon>
                  <ion-label>
                    {{ p.title | translate }}
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>

              <ion-item button *ngIf="p.child?.length>0" (click) = "p.open = !p.open"
              [class.active-parent] = "p.open" detail = "false">
              <ion-icon slot="start" [name]="p.iconOpen" *ngIf='p.open'></ion-icon>
              <ion-icon slot="start" [name]="p.iconClose" *ngIf='!p.open'></ion-icon>
                <ion-label>
                    {{ p.title | translate }}
                </ion-label>

              </ion-item>

              <ion-list *ngIf="p.open">

              <ion-menu-toggle auto-hide="false">
              <ion-item
                class="sub-item"
                *ngFor="let sub of p.child"
                [routerDirection]="'root'"
                [routerLink]="[sub.url]"
              >
                <ion-icon slot="start" [name]="sub.icon"></ion-icon>
                <ion-label>
                  {{ sub.title | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>

              </ion-list>


              </div>
            </ion-list>
          </ion-content>
        </ion-menu>
        <ion-router-outlet main></ion-router-outlet>
      </ion-split-pane>
    </ion-app>
  